import { Dialog } from "vant";

import request from "@/request";
import router from "@/router";

import { postApi, postRequest, getRequest } from "@/api/server";

import { USERINFO_KEY, TOKEN_KEY } from "@/variables";
import { isWeixin } from "../functions";

export const sendCaptcha = async (_, { mobile: phone }) => {
  const { data } = await postApi("/sms/send", { phone, codeType: 0 });
  return data;
};
export const webLogin = async (
  { commit, dispatch },
  { mobile: phone, captcha: code, captchaId: codeId }
) => {
  const info = await getRequest(
    `/account/loginWeb?channel=web&phone=${phone}&code=${code}&codeId=${codeId}`
  );

  window.localStorage.setItem("hzUseRInfo", JSON.stringify(info));
  window.localStorage.setItem(USERINFO_KEY, JSON.stringify(info));
  window.localStorage.setItem(TOKEN_KEY, JSON.stringify(info.token));

  commit("setUserFromJava", info);
  commit("setToken", info.token);

  dispatch("fetchInitData");

  return info;
};
export const xcsLogin = async (
  { commit, dispatch },
  { ua: ua}
) => {
  const info = await getRequest(
    `/account/loginXCS?channel=xcs&ua=${ua}`
  );

  window.localStorage.setItem("hzUseRInfo", JSON.stringify(info));
  window.localStorage.setItem(USERINFO_KEY, JSON.stringify(info));
  window.localStorage.setItem(TOKEN_KEY, JSON.stringify(info.token));

  commit("setUserFromJava", info);
  commit("setToken", info.token);

  dispatch("fetchInitData");

  return info;
};
export const fetchInitData = async ({ commit, dispatch }) => {
  dispatch("fetchBanners");
  dispatch("fetchGoods", {});
  dispatch("fetchHeadingNews");
  dispatch("fetchMarket", {});

  dispatch("fetchAnalysis");

  if (!isWeixin()) {
    const info = JSON.parse(window.localStorage.getItem(USERINFO_KEY));
    commit("setUserFromJava", info);
  }
};
export const fetchAnalysis = async ({ commit }) => {
  const {
    totalCustomers,
    todayCustomers: increaseCustomers,
    exploreNum: exploreViewCount,
    indexNum: homeViewCount,
  } = await postRequest("/common/customerStatic");

  commit("updateAnalysis", {
    totalCustomers,
    increaseCustomers,
    exploreViewCount,
    homeViewCount,
  });
};
export const handleWebLogin = () => {
  router.push("login");
};

export const handelCode = () => {
  return request.get("/account/toOauth");
};

export const handelWxAuth = ({ state, commit }) => {
  return request
    .get(`/account/getAccessToken?code=${state.code}`)
    .then((data) => {
      const { openId, accessToken } = data;
      commit("setOpenId", openId);
      commit("setAccessToken", accessToken);

      if (openId) {
        return request
          .get(
            `/account/getUserInfo?openId=${openId}&accessToken=${accessToken}`
          )
          .then((data) => {
            commit("setUserFromWX", JSON.parse(data));
            localStorage.setItem("huozhewang_userInfo", data);
            return true;
          })
          .catch();
      } else {
        // 如果没拿到 openId, 可能是用户拒绝授权网页访问了，暂时不做任何事情
      }
    })
    .catch();
};

export const handleWeixinLogin = (
  { state, commit },
  debugOpenId = undefined
) => {
  const openId = debugOpenId === undefined ? state.openId : debugOpenId;
  return request.get(`/account/isReg?openId=${openId}`).then((data) => {
    const { isReg } = data;
    if (isReg) {
      return request
        .get(`/account/login?openId=${openId}`)
        .then((data) => {
          localStorage.hzUseRInfo = JSON.stringify(data);
          commit("setUserFromJava", data);
          commit("setToken", data.token);
          return true;
        })
        .catch();
    } else {
      // 未注册的情况，需要先主动调用注册功能，然后再登录
      router.push("/register");
      return false;
      // console.log(state.userFromWX);
      // return request.post('/account/reg', {
      //   openId: openid,
      //   userName: nickname,
      //   headImg: headimgurl,
      //   phone: ''
      // })
      //   .then(data => {
      //     return request.get(`/account/login?openId=${ openId }`)
      //       .then(data => {
      //         console.log(data);
      //         commit('setUserFromJava', data);
      //         commit('setToken', data.token);
      //         return true
      //       })
      //       .catch()
      //   })
      //   .catch()
    }
  });
};

export const handleOrder = ({ dispatch }, param = []) => {
  if (Array.isArray(param) && !param.length) {
    return Dialog.alert({
      message: "至少选择一个商品进行结算",
      confirmButtonText: "好的",
      theme: "round-button",
    });
  }

  return request.post("/orderBill/createBill", param).then((data) => {
    const { order_bill_id } = data;
    if (parseFloat(data.order_price) <= 0) {
      router.push({
        name: "paySuccess",
        query: {
          result: 1,
        },
      });
    } else {
      dispatch("handlePay", { orderId: order_bill_id }).then(() => {
        return true;
      });
    }
  });
};

export const handlePay = (_, { orderId }) => {
  /*
   * 第一步：获取支付信息，微信接口需要
   * 第二步：调起微信支付
   * 第三步：收到回调，前端做响应，如果需要的
   * */

  console.log("orderId", orderId); // for debug

  request.post("/pay/wxUnifiedorder", { id: orderId }).then((data) => {
    const { appId, nonceStr, prepay_id, signType, timeStamp } = data;

    function onBridgeReady() {
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId,
          nonceStr,
          timeStamp,
          prepay_id,
          signType,
          package: data.package,
          paySign: data.sign,
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            router.push({
              name: "paySuccess",
              query: {
                result: 1,
              },
            });
          } else {
            router.push({
              name: "paySuccess",
              query: {
                result: 0,
              },
            });
          }
        }
      );
    }

    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
        document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
      }
    } else {
      onBridgeReady();
    }
  });
};

export const fetchBanners = ({ commit }) => {
  return request
    .post("/bannerNews/bannerPages", { page: 1, size: 100 })
    .then((data) => {
      commit("setHomeBanners", data.list);
      return {
        rows: data.list,
        total: data.total,
      };
    });
};

export const fetchHeadingNews = ({ commit }) => {
  return request
    .post("/headingNews/headingPage", { page: 1, size: 100 })
    .then((data) => {
      commit("setHomeHeadingNews", data.list);
      return {
        rows: data.list,
        total: data.total,
      };
    });
};

export const fetchGoods = ({ commit }, param) => {
  const { goodsCode, goodsName, page = 1, size = 20 } = param;
  return request
    .post("/goodsInfo/goodsPages", { goodsCode, goodsName, page, size })
    .then((data) => {
      commit("setHomeGoods", data.list);
      return {
        rows: data.list,
        total: data.total,
      };
    });
};

export const addShopCar = ({ state, commit }, target) => {
  const result = [].concat(state.shopCar, target);
  commit("setShopCar", result);
};

export const removeShopCar = ({ state, commit }, target) => {
  const result = state.shopCar.filter(
    (v) => v.goodsInfo.id !== target.goodsInfo.id
  );
  commit("setShopCar", result);
};

export const clearShopCar = ({ commit }) => {
  commit("setShopCar", []);
};

export const fetchOrders = (_, param) => {
  let startTime = "",
    endTime = "";
  const { orderNo, status, page = 1, size = 100 } = param;
  return request
    .post("/orderBill/myOrders", {
      orderNo,
      status,
      startTime,
      endTime,
      page,
      size,
    })
    .then((data) => {
      return {
        rows: data.list,
        total: data.total,
      };
    });
  // return Promise.resolve({
  //   rows: [{
  //     controlStatus: 0,
  //     customerId: 1,
  //     customerNickName: '小太阳',
  //     customerPhone: '15298776682',
  //     orderNo: 'xxxx',
  //     ordersPrice: 45,
  //     payTime: '',
  //     payType: '微信',
  //     price: '22',
  //     status: 0,
  //     wxOrder: '微信订单号'
  //   }],
  //   total: 1
  // })
};

export const cancelOrder = (_, { orderId }) => {
  return request.post("/orderBill/cancleBill", { id: orderId }).then(() => {
    return true;
  });
};
export const deleteOrder = (_, { id }) => {
  return request.post("/orderBill/deleteBill", { id }).then(() => {
    return true;
  });
};

export const fetchMarket = ({ commit }, param) => {
  const { page = 1, size = 20 } = param;
  return request.post("/market/marketPages", { page, size }).then((data) => {
    commit("setHomeMarkets", data.list);
    return {
      rows: data.list,
      total: data.total,
    };
  });
};

export const fetchMarketPrice = (_, param) => {
  const { marketId, start, end } = param;
  return request
    .post("/market/priceOfMarket", {
      marketId,
      start,
      end,
      page: 1,
      size: 10000,
    })
    .then((data) => {
      return {
        rows: data,
      };
    });
};

export const getDynamicList = (_, param) => {
  let { page = 1, size = 20, publishedId = 0, keyWord } = param;
  let data = {
    page,
    size,
    publishedId,
    keyWord,
  };
  if (parseInt(param.publishedId) === 0) {
    delete data.publishedId;
  }
  return request.post("/explore/showMsg", data).then((data) => {
    return {
      rows: data.content,
      total: data.totalElements,
    };
  });
  // if (parseInt(param.publishedId) === 0) {
  //     const { page=1, size=20 } = param;
  //     return request.post('/explore/showMsg', { page, size}).then(data => {
  //         return {
  //             rows: data.content,
  //             total: data.totalElements
  //         }
  //     })
  // } else {
  //     const { page=1, size=20, publishedId=0 } = param;
  //     return request.post('/explore/showMsg', { page, size, publishedId}).then(data => {
  //         return {
  //             rows: data.content,
  //             total: data.totalElements
  //         }
  //     })
  // }
};

export const getUnreadMessageList = (_, param) => {
  const { page = 1, size = 20 } = param;
  return request
    .post("/explore/unreadMessageList", { page, size })
    .then((data) => {
      return {
        rows: data.unReadExploreMessagePage.content,
        total: data.unReadExploreMessagePage.totalElements,
      };
    });
};
